const HexAndRbga = require('hex-and-rgba')

export const GnssLightColor = {
  OFF: HexAndRbga.rgbaToHex(255, 255, 255, 64.0 / 255),
  REF_LINE_DETECTING_LOW: HexAndRbga.rgbaToHex(255, 0, 0, 192.0 / 255),
  REF_LINE_DETECTING_HIGH: HexAndRbga.rgbaToHex(255, 255, 0, 192.0 / 255),
  HIGH: HexAndRbga.rgbaToHex(0, 255, 0, 192.0 / 255),
  LOW: HexAndRbga.rgbaToHex(0, 196, 255, 192.0 / 255),
  NO_POS: HexAndRbga.rgbaToHex(255, 255, 0, 192.0 / 255),
  NO_CONN: HexAndRbga.rgbaToHex(255, 0, 0, 192.0 / 255),
}

/**
 * https://github.com/agri-info-design/navi/blob/master/AgriBusNavi/AgriBusAppModelLib/Navigation/GnssProperties.cs#L65
 */
export const GnssStatusEnum = {
  NoConnection: { value: -1, color: GnssLightColor.NO_CONN, text: 'NO GNSS', sort: 1 },
  NoGps: { value: 0, color: GnssLightColor.NO_POS, text: 'NO POS', sort: 2 },
  Single: { value: 1, color: GnssLightColor.LOW, text: 'SINGLE', sort: 7 },
  DGps: { value: 2, color: GnssLightColor.HIGH, text: 'D-GNSS', sort: 8 },
  Ppp: { value: 3, color: GnssLightColor.HIGH, text: 'PPP', sort: 6 },
  RtkFix: { value: 4, color: GnssLightColor.HIGH, text: 'FIX', sort: 10 },
  RtkFloat: { value: 5, color: GnssLightColor.LOW, text: 'FLOAT', sort: 9 },
  Edr: { value: 6, color: GnssLightColor.LOW, text: 'EDR', sort: 3 },
  Manual: { value: 7, color: GnssLightColor.LOW, text: 'MANUAL', sort: -1 },
  Simulation: { value: 8, color: GnssLightColor.LOW, text: 'SIM', sort: 4 },
  AndroidLocation: { value: 100, color: GnssLightColor.LOW, text: 'ANDROID', sort: 5 },
}

export default class GnssStatus {
  static getTextFromInteger(value) {
    for (let key of Object.keys(GnssStatusEnum)) {
      if (GnssStatusEnum[key].value === value) {
        return GnssStatusEnum[key].text
      }
    }
    return 'Unknown'
  }

  static getLightColorFromInteger(value) {
    for (let key of Object.keys(GnssStatusEnum)) {
      if (GnssStatusEnum[key].value === value) {
        return GnssStatusEnum[key].color
      }
    }
    return '#ccc'
  }

  static getSortFromInteger(value) {
    for (let key of Object.keys(GnssStatusEnum)) {
      if (GnssStatusEnum[key].value === value) {
        return GnssStatusEnum[key].sort
      }
    }
    return 0
  }

  static getTextFromSort(value) {
    for (let key of Object.keys(GnssStatusEnum)) {
      if (GnssStatusEnum[key].sort === value) {
        return GnssStatusEnum[key].text
      }
    }
    return 'Unknown'
  }
}

// switch (GnssStatus)
// {
//   case (int)GnssProperties.GnssStatusEnum.NoConnection:
//     gnssStatusText = "NO GNSS";
//     _Paint.Color = DefaultLightColorNoConn;
//     break;
//   case (int)GnssProperties.GnssStatusEnum.NoGps:
//     gnssStatusText = "NO POS";
//     _Paint.Color = DefaultLightColorNoPos;
//     break;
//   case (int)GnssProperties.GnssStatusEnum.Single:
//     gnssStatusText = GetGnssStatusText("SINGLE");
//     _Paint.Color = DefaultLightColorLow;
//     break;
//   case (int)GnssProperties.GnssStatusEnum.DGps:
//     gnssStatusText = GetGnssStatusText("D-GNSS");
//     _Paint.Color = DefaultLightColorHigh;
//     break;
//   case (int)GnssProperties.GnssStatusEnum.Ppp:
//     gnssStatusText = GetGnssStatusText("PPP");
//     _Paint.Color = DefaultLightColorHigh;
//     break;
//   case (int)GnssProperties.GnssStatusEnum.RtkFix:
//     gnssStatusText = GetGnssStatusText("FIX");
//     _Paint.Color = DefaultLightColorHigh;
//     break;
//   case (int)GnssProperties.GnssStatusEnum.RtkFloat:
//     gnssStatusText = GetGnssStatusText("FLOAT");
//     _Paint.Color = DefaultLightColorLow;
//     break;
//   case (int)GnssProperties.GnssStatusEnum.Edr:
//     gnssStatusText = GetGnssStatusText("EDR");
//     _Paint.Color = DefaultLightColorLow;
//     break;
//   case (int)GnssProperties.GnssStatusEnum.Manual:
//     gnssStatusText = GetGnssStatusText("MANUAL");
//     _Paint.Color = DefaultLightColorLow;
//     break;
//   case (int)GnssProperties.GnssStatusEnum.Simulation:
//     gnssStatusText = GetGnssStatusText("SIM");
//     _Paint.Color = DefaultLightColorLow;
//     break;
// }
